/**
 * 其知网 分类管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>代理人管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入代理人名称"></el-input>
      </el-form-item>
      <el-form-item label="类型：">
        <el-select size="small" v-model="formInline.type" style="width:140px" placeholder="请选择" clearable>
          <el-option v-for="type in expertType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" align="center" :formatter="typeFormat" label="专家类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="practice_id" align="center" label="执业证号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="work_years" align="center" label="工作年限" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="rate" align="center" label="授权率" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="country" align="center" label="国家" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="region" align="center" label="所在地区" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="admin_name" align="center" label="照片" show-overflow-tooltip>
        <template slot-scope="scope">
        　  <img :src="scope.row.head" width="65" height="80" class="head_pic"/>
        </template>
      </el-table-column>
      <el-table-column prop="majors" align="center" label="擅长领域" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="directions" align="center" label="擅长行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="upd_time" align="center" label="更新时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">详情编辑</el-button> -->
          <el-button size="mini" type="danger" @click="delAgent(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专家名称" prop="name">
              <el-input size="small" v-model="infoForm.name" auto-complete="off" placeholder="请填写专家姓名"></el-input>
            </el-form-item>
            <el-form-item label="服务客户" prop="serving_customer">
              <el-input size="large" type="textarea" v-model="infoForm.serving_customer" placeholder="请填写服务客户,例如:西南石油大学,四川大学" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="业务专长" prop="business">
              <el-input size="large" type="textarea" v-model="infoForm.business" placeholder="请填写业务专长,例如:专利代理,专利布局" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="所获荣誉" prop="honor">
              <el-input size="large" type="textarea" v-model="infoForm.honor" placeholder="请填写所获荣誉" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="代表案列" prop="case">
              <el-input size="large" type="textarea" v-model="infoForm.case" placeholder="请填写代表案例,例如:《袖扣》,《一种金刚钻头》" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="代理详情" prop="rate_proportion">
              <el-input size="small" auto-complete="off" v-model="infoForm.rate_proportion" placeholder="无需填写,接口查询" disabled></el-input>
            </el-form-item>

            <el-form-item label="国家" prop="country">
              <el-select size="small" v-model="infoForm.country" style="width:140px" placeholder="请选择">
                <el-option v-for="type in countryData" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="所在地区" prop="region">
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange">
                </el-cascader>
            </el-form-item>

            <el-form-item label="所在城市" prop="city">
              <el-input size="small" auto-complete="off" v-model="infoForm.city" placeholder="请填写城市,如:成都"></el-input>
            </el-form-item>

            <el-form-item label="代理人图片">
              <el-upload
                class="avatar-uploader"
                action="https://zlbb.qzhip.com/index.php/index/base/uploadAgentFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="infoForm.pre_head" :src="infoForm.pre_head" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作年限" prop="work_years">
              <el-input size="small" v-model="infoForm.work_years" auto-complete="off" placeholder="请填写工作年限"></el-input>
            </el-form-item>
            <el-form-item label="毕业院校" prop="school">
              <el-input size="small" auto-complete="off" v-model="infoForm.school" placeholder="请填写毕业院校"></el-input>
            </el-form-item>
            <!-- <el-form-item label="资格证号" prop="card_id">
              <el-input size="small" v-model="infoForm.card_id" auto-complete="off" placeholder="请填写资格证号"></el-input>
            </el-form-item> -->
            <el-form-item label="执业证号" prop="practice_id">
              <el-input size="small" auto-complete="off" v-model="infoForm.practice_id" placeholder="请填写执业证号"></el-input>
            </el-form-item>
            <el-form-item label="执业机构" prop="organization">
              <el-input size="small" auto-complete="off" v-model="infoForm.organization" placeholder="请填写执业机构"></el-input>
            </el-form-item>
            <el-form-item label="机构代码" prop="organization_code">
              <el-input size="small" auto-complete="off" v-model="infoForm.organization_code" placeholder="请填写机构代码"></el-input>
            </el-form-item>
            <el-form-item label="职级" prop="rank">
              <el-input size="small" auto-complete="off" v-model="infoForm.rank" placeholder="请填写职级"></el-input>
            </el-form-item>
            <el-form-item label="专家类型" prop="type">
              <el-select size="small" v-model="infoForm.type" style="width:140px" placeholder="请选择" @change="expertTypeChange">
                <el-option v-for="type in expertTypes" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="电子邮箱" prop="email">
              <el-input size="small" auto-complete="off" v-model="infoForm.email" placeholder="请填写电子邮箱"></el-input>
            </el-form-item>

            <el-form-item label="联系电话" prop="tel">
              <el-input size="small" auto-complete="off" v-model="infoForm.tel" placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item label="代理总量" prop="agent_detail">
              <el-input size="small" auto-complete="off" v-model="infoForm.agent_detail" placeholder="无需填写,接口查询" disabled></el-input>
            </el-form-item>

            <el-form-item label="办公地址" prop="work_address">
              <el-input size="small" auto-complete="off" v-model="infoForm.work_address" placeholder="请填写办公地址"></el-input>
            </el-form-item>

            <el-form-item label="授权率" prop="rate">
              <el-input size="small" v-model="infoForm.rate" auto-complete="off" placeholder="请填写授权率,例如80%可直接填写80"></el-input>
            </el-form-item>
            
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="经历简介" prop="desc">
              <el-input size="large" type="textarea" v-model="infoForm.desc" placeholder="请填写经历简介" auto-complete="off"></el-input>
        </el-form-item>
        <div v-if="showAgent">
        <el-form-item label="证书擅长领域">
              <el-radio-group v-model="infoForm.major">
                <el-radio :label="item.name" :key="item.name" v-for="item in majorList">{{item.name}}</el-radio>
              </el-radio-group>
        </el-form-item>

        <el-form-item label="实际擅长领域">
              <el-checkbox-group style="display: inline-block" v-model="checkedMajorsEquipments">
                <el-checkbox
                v-for="data in majorList" 
                :label="data.name"
                :key="data.id"
                :checked="data.checked">
                </el-checkbox>
              </el-checkbox-group>
        </el-form-item>

       <el-form-item label="证书擅长行业">
              <el-radio-group v-model="infoForm.direction">
                <el-radio :label="item.name" :key="item.name" v-for="item in categoryList" style="margin-top: 10px;">{{item.name}}</el-radio>
              </el-radio-group>
        </el-form-item>

        <el-form-item label="实际擅长行业">
              <el-checkbox-group style="display: inline-block" v-model="checkedDirectionsEquipments">
                <el-checkbox
                v-for="data in categoryList" 
                :label="data.name"
                :key="data.id"
                :checked="data.checked">
                </el-checkbox>
              </el-checkbox-group>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button size="mini" type="primary" @click="submitForm('infoForm')">保存</el-button>
          <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webGetCategory, webAgentList, webUrl, webEditAgent, webDelAgent, webAgentCate, webAgentMajor } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
import {regionData,CodeToText,provinceAndCityData} from 'element-china-area-data'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加分类',
      showAgent: false,// 是否显示代理人领域
      multipleSelection: [],
      categoryList: [],
      majorList: [],
      checkedDirectionsEquipments: [],
      checkedMajorsEquipments: [],
      options: provinceAndCityData,
      selectedOptions: [],
      addtions:{},			//存储地址数据
      countryData: [
        { key: '中国', value: '中国' },
        { key: '美国', value: '美国' },
        { key: '欧洲', value: '欧洲' },
        { key: '日本', value: '日本' },
        { key: '韩国', value: '韩国' },
        { key: '英国', value: '英国' },
        { key: '加拿大', value: '加拿大' },
        { key: '澳大利亚', value: '澳大利亚' },
        { key: '俄罗斯', value: '俄罗斯' },
        { key: '印度', value: '印度' },
        { key: '南美洲', value: '南美洲' },
        { key: '非洲', value: '非洲' },
        { key: '阿根廷', value: '阿根廷' },
      ],
      expertType: [
        { key: '全部', value: 0 },
        { key: '专利代理师', value: 1 },
        { key: '技术经理人', value: 2 },
        { key: '专利律师', value: 3 },
      ],
      expertTypes: [
        { key: '专利代理师', value: 1 },
        { key: '技术经理人', value: 2 },
        { key: '专利律师', value: 3 },
      ],
      infoForm: {
        id: '',
        name: '',
        work_years: '',
        rate: '',
        region: '',
        head: '',
        pre_head: '',
        sort: '',
        school: '',
        case: '',
        desc: '',
        email: '',
        organization: '',
        organization_code: '',
        practice_id: '',
        rate_proportion: '',
        serving_customer: '',
        business: '',
        agent_detail: '',
        direction: '',
        tel: '',
        work_address: '',
        country: '',
        major: '',
        city: '',
        type: '',
        honor: '',
        rank: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        name: '',
        type: 0
      },
      imageUrl: '',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      infoFormRules: {
        name: [{required: true, message: '请输入代理人名称', trigger: 'blur'}],
        // card_id: [{required: true, message: '请输入资格证号', trigger: 'blur'}],
        // work_years: [{required: true, message: '请输入工作年限', trigger: 'blur'}],
        // rate: [{required: true, message: '请输入授权率', trigger: 'blur'}],
        country: [{required: true, message: '请选择国家', trigger: 'blur'}],
        head: [{required: true, message: '请上传代理人图片', trigger: 'blur'}],
        // direction: [{required: true, message: '请勾选证书擅长行业', trigger: 'blur'},],
        // major: [{required: true, message: '请勾选证书擅长领域', trigger: 'blur'},],
        school: [{required: true, message: '请输入毕业院校', trigger: 'blur'}],
        type: [{required: true, message: '请选择专家类型', trigger: 'blur'}],
        // agent_detail:[{}],
        // practice_id: [{required: true, message: '请输入执业证号', trigger: 'blur'}],
        // organization: [{required: true, message: '请输入执业机构', trigger: 'blur'}],
        // organization_code: [{required: true, message: '请输入机构代码', trigger: 'blur'}],
        business: [{required: true, message: '请输入业务专长', trigger: 'blur'},],
        // email: [{required: true, message: '请输入电子邮箱', trigger: 'blur'}],
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getCate()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
       this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webAgentList(parameter)
        .then(res => {
          this.loading = false
          // console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    getCate(){
        webGetCategory()
            .then(res => {
              this.loading = false
              // console.log(res);
              res = checkLogin(res)
              if (res.code == 200) {
                this.categoryList = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
            })

        webAgentMajor()
                    .then(res => {
                      this.loading = false
                      // console.log(res);
                      res = checkLogin(res)
                      if (res.code == 200) {
                        this.majorList = res.data
                      } else {
                        this.$message({
                          type: 'info',
                          message: res.msg
                        })
                      }
                    })
                    .catch(err => {
                      this.loading = false
                      this.$message.error('登陆已过期,请重新登陆!')
                    })

    },
    handleChange (value) {
      //我们选择地址后，selectedOptions 会保存对应的区域码，例如北京的区域码为'110000'
      //我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      // 如果选择的国家不是中国，就不需要选择地区
        console.log('国家:'+this.infoForm.country)
        if(this.infoForm.country != '中国'){
            this.$message({
                type: 'warning',
                message: '非中国代理人可以不选择地区!'
              })
            return false
        }
        this.addtions.selectedOptions = value
        var name = ''
        this.selectedOptions.map(item => name += CodeToText[item])
        // this.addtions.names = name
        this.infoForm.region = name
        // console.log('地区:'+this.addtions.names)
        console.log(this.addtions)
      },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 专家类型
    typeFormat:function(row,column){
        if(row.type == 1){
            return '专利代理师'
        }else if(row.type == 2){
            return '技术经理人'
        }else if(row.type == 3){
            return '专利律师'
        }else{
            return '未知'
        }
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleEdit: function(index, row) {
      this.options.forEach(function(item,index){
        item.children = ''
      });
      // console.log(this.options)
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑专家'
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        // this.infoForm.card_id = row.card_id
        this.infoForm.region = row.region
        this.infoForm.work_years = row.work_years
        this.infoForm.rate = row.rate
        this.infoForm.head = row.head
        this.infoForm.pre_head = row.head
        this.infoForm.sort = row.sort
        this.checkedDirectionsEquipments = row.directions.split(',')
        this.checkedMajorsEquipments = row.majors.split(',')
        this.selectedOptions = row.region_code.split(',')
        this.infoForm.major = row.major
        this.infoForm.direction = row.direction
        this.infoForm.email = row.email
        this.infoForm.case = row.case
        this.infoForm.business = row.business
        this.infoForm.school = row.school
        this.infoForm.practice_id = row.practice_id
        this.infoForm.organization = row.organization
        this.infoForm.organization_code = row.organization_code
        this.infoForm.agent_detail = row.agent_detail
        this.infoForm.rate_proportion = row.rate_proportion
        this.infoForm.desc = row.desc
        this.infoForm.evaluate = row.evaluate
        this.infoForm.serving_customer = row.serving_customer
        this.infoForm.tel = row.tel
        this.infoForm.work_address = row.work_address
        this.infoForm.country = row.country
        this.infoForm.city = row.city
        this.infoForm.type = row.type
        this.infoForm.rank = row.rank
        this.infoForm.honor = row.honor
        if(row.type == 1){
          this.showAgent = true
        }else{
          this.showAgent = false
        }
      } else {
        this.title = '添加专家'
        this.infoForm.id = ''
        this.infoForm.name = ''
        // this.infoForm.card_id = ''
        this.infoForm.region = ''
        this.infoForm.work_years = ''
        this.infoForm.rate = ''
        this.infoForm.head = ''
        this.infoForm.pre_head = ''
        this.infoForm.category_name = []
        this.infoForm.sort = ''
        this.checkedDirectionsEquipments = []
        this.checkedMajorsEquipments = []
        this.selectedOptions = []
        this.infoForm.email = ''
        this.infoForm.case = ''
        this.infoForm.business = ''
        this.infoForm.school = ''
        this.infoForm.practice_id = ''
        this.infoForm.organization = ''
        this.infoForm.organization_code = ''
        this.infoForm.agent_detail = ''
        this.infoForm.rate_proportion = ''
        this.infoForm.desc = ''
        this.infoForm.evaluate = ''
        this.infoForm.serving_customer = ''
        this.infoForm.tel = ''
        this.infoForm.work_address = ''
        this.infoForm.country = ''
        this.infoForm.major = ''
        this.infoForm.direction = ''
        this.infoForm.city = ''
        this.infoForm.type = ''
        this.infoForm.rank = ''
        this.infoForm.honor = ''
        this.showAgent = false
      }
    },

    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.head = res.data.save_url
          this.infoForm.pre_head = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },

    // 编辑、增加页面保存方法
    submitForm(infoForm) {
      this.infoForm.directions = this.checkedDirectionsEquipments
      this.infoForm.majors = this.checkedMajorsEquipments
      // if(this.infoForm.directions.length <= 0){
      //     this.$message({
      //             type: 'error',
      //             message: '请勾选擅长行业'
      //           })
      //         return false
      // }
      // if(this.infoForm.majors.length <= 0){
      //     this.$message({
      //             type: 'error',
      //             message: '请勾选擅长专业'
      //           })
      //         return false
      // }
      this.$refs[infoForm].validate(valid => {
        if (valid) {
          // 获取地区code值
          this.infoForm.region_code = this.selectedOptions.join(',')
          webEditAgent(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统错误！')
            })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delAgent(index, row) {
       this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          webDelAgent(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 专家类型选择
    expertTypeChange(e) {
     if(this.infoForm.type == 1){
        this.showAgent = true
     }else{
        this.showAgent = false
     }
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Agent.vue